import { useRef as b, useEffect as m } from "react";
function E(f, n, c = !1) {
  const r = b(null);
  m(() => {
    if (!f) return;
    r.current = document.activeElement, setTimeout(() => {
      var e;
      (e = n.current) == null || e.focus();
    }, 0);
    const s = (e) => {
      if (e.key !== "Tab") return;
      const t = n.current;
      if (!t) return;
      const u = t.querySelectorAll(
        'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable]'
      ), l = Array.from(u).filter((p) => {
        const v = globalThis.getComputedStyle(p);
        if (v.display === "none" || v.visibility === "hidden")
          return !1;
        let o = p.parentElement;
        for (; o && o !== t; ) {
          const y = globalThis.getComputedStyle(o);
          if (y.display === "none" || y.visibility === "hidden")
            return !1;
          o = o.parentElement;
        }
        return !0;
      });
      if (!l.length) {
        e.preventDefault();
        return;
      }
      const a = l[0], d = l[l.length - 1], i = t.getRootNode().activeElement;
      if (c && (!i || !t.contains(i))) {
        e.preventDefault(), a.focus();
        return;
      }
      e.shiftKey ? i === a && (e.preventDefault(), d.focus()) : i === d && (e.preventDefault(), a.focus());
    };
    if (c) {
      const e = n.current, u = (e == null ? void 0 : e.getRootNode()) || document;
      return u.addEventListener("keydown", s, !0), () => {
        u.removeEventListener(
          "keydown",
          s,
          !0
        ), r.current && r.current.focus();
      };
    } else {
      const e = n.current;
      return e == null || e.addEventListener("keydown", s), () => {
        e == null || e.removeEventListener("keydown", s), r.current && r.current.focus();
      };
    }
  }, [f, n, c]);
}
export {
  E as useFocusTrap
};
//# sourceMappingURL=useFocusTrap.mjs.map
